import React from 'react'
import PlantillaScreen from '../../../helpers/PlantillaScreen'
import { useHistory } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

export const ContactoMainScreen = () => {
    const history = useHistory();

    return (
        <PlantillaScreen
            titulo={"CONTACTOS"}
            className={"analisis-solicitud-credito"}
            className_main={2}
        >
            {/* <LoaderScreen loader={loader} /> */}
            <div className="facturacion-maquinaria-actions">
                <div
                    className="facturacion-maquinaria-actions-regresar"
                    onClick={() => history.goBack()}
                >
                    <ArrowBackIcon /> Regresar
                </div>
            </div>
        </PlantillaScreen>
    )
}
